import React from 'react';
import moment from 'moment';
import useSetExport from '@components/export/useSetExport';


function useSetViewerSessionsExport({ data, columns, interval }) {

  const headers = columns.map( ({ title, dataKey }) => {
    const type = dataKey === 'SessionStartTime' ? 'timestamp' : null;
    return ({ title, key: dataKey, type })
  });

  const intervalStr = `(${moment(interval.from).format()} - ${moment(interval.to).format()})`

  useSetExport({
    pageKey: 'trends',
    sectionKey: 'dimensions-panel',
    widgetKey: 'viewer-sessions',
    widgetInfo: {
      title: `Subset of Viewer Sessions (up to 1500) ${intervalStr}`
    },
    data,
    headers,
  });

}

export default useSetViewerSessionsExport;
